import { Mail, Phone, MapPin } from "lucide-react";
import { useState, useEffect } from "react";
import { motion,AnimatePresence } from "framer-motion";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function RegMessage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Registrar Message | Bandarban University",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-600 to-teal-500 text-white py-16 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Message from the Registrar</h1>
          <p className="text-lg opacity-90">
            Guiding the future with vision, leadership, and integrity.
          </p>
        </div>
      </section>

      {/* VC Profile Section */}
      <section className="max-w-6xl mx-auto py-16 px-6 grid lg:grid-cols-5 gap-10 items-center">
			<motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
            >
				<div className="relative">

				  <div className="absolute -inset-4 bg-gradient-to-r from-green-500 to-teal-500 rounded-3xl blur-xl opacity-30" />

				  <img
					src="/assets/img/jashim.jpeg"
					alt="Registrar"
					className="relative rounded-3xl shadow-2xl w-full object-cover"
				  />

				  <div className="bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-lg">
					<h4 className="font-bold text-green-700">
					  Prof. Md. Jashim Uddin Khan
					</h4>
					<p className="text-sm text-gray-600">
					  Registrar
					</p>
					<p className="text-sm text-gray-600">
					  Bandarban University
					</p>
				  </div>

				</div>
           </motion.div>
		   
		   <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
            >
				<h2 className="text-4xl font-bold mb-6 text-slate-800">
				  Messasge From Registrar
				</h2>
				<div className="space-y-6 text-gray-700 leading-8 text-justify">
					<p>It is my great pleasure to extend warm greetings to all students, faculty members, staff, guardians, and well-wishers of Bandarban University.</p>

					<p>Bandarban University is committed to fostering academic excellence, integrity, innovation, and social responsibility. As Registrar, I am dedicated to ensuring efficient academic administration, transparent governance, and a supportive environment where students can thrive both intellectually and personally.</p>

					<p>We believe that higher education is not only about acquiring knowledge but also about building character, leadership, and a strong sense of community. Through collaborative efforts among our academic and administrative teams, we strive to provide quality services and maintain the highest standards in all university operations.</p>

					<p>I encourage all members of our university community to actively participate in academic activities, research initiatives, and co-curricular engagements that enrich campus life and contribute to national development.</p>

					<p>Together, let us continue to uphold the values and vision of Bandarban University and work toward a brighter future.</p>
				</div> 
			</motion.div>
      </section>

      {/* Vision & Mission */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Vision</h3>
            <p>To become a leading institution of higher learning in Asia.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Mission</h3>
            <p>To nurture creativity, research, and leadership through quality education.</p>
          </div>
          <div className="p-6 bg-gray-100 rounded-xl shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-2">Goals</h3>
            <p>Expanding research opportunities and strengthening global partnerships.</p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="bg-gradient-to-r from-teal-600 to-green-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-4">
          <h3 className="text-2xl font-bold mb-4">Office of the Registrar</h3>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <div className="flex items-center gap-2">
              <MapPin size={20} /> <span>K.B Road, Shualok, Post Office: Shualok - 4600, Bandarban Sadar, Bangladesh</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={20} /> <span>+8801318-305900</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={20} /> <span>registrar@bubban.ac.bd</span>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg shadow hover:bg-gray-100">
            Request Appointment
          </button>
        </div>
      </section>
    </div>
  );
}
